export default function Demerits() {
  const demerits = [
    {
      icon: 'ri-calendar-line',
      title: 'ポイント有効期限が1年間',
      description: 'ポイントの有効期限は最終利用日から1年間。定期的にカードを利用していれば実質無期限ですが、長期間利用しないとポイントが失効してしまう点に注意が必要です。'
    },
    {
      icon: 'ri-exchange-dollar-line',
      title: 'ポイント交換に手間がかかる',
      description: 'ポイントを使うには、Pontaポイントやdポイントなどへの交換手続きが必要です。直接カード利用代金に充当できないため、ひと手間かかる点がデメリットです。'
    },
    {
      icon: 'ri-bank-card-line',
      title: 'ETCカードに発行手数料（Visa/Mastercard）',
      description: 'JCBブランドは無料ですが、VisaとMastercardブランドでETCカードを発行する場合は1,100円の発行手数料がかかります。年会費は無料です。'
    },
    {
      icon: 'ri-store-line',
      title: '特定店舗での優待が少ない',
      description: '基本還元率は高いものの、特定の百貨店やショッピングモールでの優待特典は他社カードと比べて少なめ。特定店舗でのお得さを重視する方には物足りない可能性があります。'
    }
  ];

  return (
    <section className="py-16 bg-white">
      <div className="max-w-6xl mx-auto px-4">
        <h2 className="text-3xl font-bold text-center text-gray-900 mb-4">
          注意点・デメリット
        </h2>
        <p className="text-center text-gray-600 mb-12 max-w-2xl mx-auto">
          申込み前に確認しておきたいポイントをまとめました
        </p>
        <div className="grid md:grid-cols-2 gap-6">
          {demerits.map((demerit, index) => (
            <div
              key={index}
              className="bg-gradient-to-br from-gray-50 to-white rounded-xl p-6 shadow-lg border border-gray-200 hover:border-orange-300 transition-all duration-300"
            >
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-orange-100 rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className={`${demerit.icon} text-orange-600 text-xl w-6 h-6 flex items-center justify-center`}></i>
                </div>
                <div>
                  <h3 className="text-lg font-bold text-gray-900 mb-2">
                    {demerit.title}
                  </h3>
                  <p className="text-gray-600 leading-relaxed">
                    {demerit.description}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
        <div className="mt-12 bg-gradient-to-r from-orange-50 to-red-50 rounded-xl p-8 border border-orange-200">
          <div className="flex items-start gap-4">
            <div className="w-12 h-12 bg-orange-500 rounded-lg flex items-center justify-center flex-shrink-0">
              <i className="ri-lightbulb-line text-white text-xl w-6 h-6 flex items-center justify-center"></i>
            </div>
            <div>
              <h3 className="text-xl font-bold text-gray-900 mb-2">
                デメリットを上回る高還元率
              </h3>
              <p className="text-gray-700 leading-relaxed">
                いくつかの注意点はありますが、業界最高水準の1.2%還元率という圧倒的なメリットがあります。定期的にカードを利用し、ポイント交換の手間を惜しまなければ、年会費無料で最もお得なカードの一つと言えるでしょう。
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
